import '~/core/application'
import Swiper, { Navigation, Pagination } from 'swiper'
import onEnter from '~/core/onEnter'

const setupSwiper = (): void => {
  Swiper.use([Navigation, Pagination])

  new Swiper('.magi-vault-swiper-board-area__swiper', {
    slidesPerView: 2,
    spaceBetween: 2,
    centeredSlides: true,
    loop: true,
    pagination: {
      el: '.swiper-pagination',
      type: 'progressbar',
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      600: {
        slidesPerView: 3,
        spaceBetween: 8,
        slidesPerGroup: 3,
        centeredSlides: false,
        loop: true,
      },
      1024: {
        slidesPerView: 5,
        spaceBetween: 12,
        slidesPerGroup: 5,
        centeredSlides: false,
        loop: true,
      },
    },
  })
}
onEnter(() => {
  setupSwiper()
})
